export function getElectricFuelCells(percentage: number): number[] {
  let checkedPercentage = percentage;
  if (percentage < 0) checkedPercentage = 0;
  if (percentage > 100) checkedPercentage = 100;

  const filledCount = Math.round((checkedPercentage / 100) * 10);

  return [...new Array(filledCount).fill(1), ...new Array(10 - filledCount).fill(0)];
}
